// Level badge — rounded white pill with the level number, sized to anchor
// at the bottom of the AvatarCircle. The mockup shows a small white
// rectangle with the digit "7" hanging off the bottom of the head; this
// component matches that shape.

const STYLES_ID = 'level-badge-styles';
const STYLES = `
.level-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #FFFFFF;
  color: #0E3C4A;
  font-family: 'Chewy', ui-sans-serif, system-ui, sans-serif;
  border-radius: 6px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.22), inset 0 -2px 0 rgba(0,0,0,0.08);
  padding: 0 6px;
  min-width: 22px;
  text-align: center;
  line-height: 1;
}
`;

export interface LevelBadgeOptions {
  level: number;
  /** Font size in px. Defaults to 18. */
  fontSize?: number;
  /** Pill height in px. Defaults to 22. */
  height?: number;
}

export function makeLevelBadge(opts: LevelBadgeOptions): HTMLElement {
  ensureStyles();
  const el = document.createElement('div');
  el.className = 'level-badge';
  el.textContent = String(Math.max(0, Math.min(9999, opts.level | 0)));
  el.style.fontSize = `${opts.fontSize ?? 18}px`;
  el.style.height = `${opts.height ?? 22}px`;
  return el;
}

function ensureStyles(): void {
  if (document.getElementById(STYLES_ID)) return;
  const style = document.createElement('style');
  style.id = STYLES_ID;
  style.textContent = STYLES;
  document.head.appendChild(style);
}
